export enum ChangePasswordStep {
    OldPassword,
    NewPassword,
}

export enum ChangeLoginStep {
    Password,
    NewLogin,
    Confirmation,
}

export enum CreateLoginStep {
    LoginData,
    Confirmation,
}
